import React, {useEffect, useState} from 'react';
import {alpha, Box, Breadcrumbs, Stack, Tab, Typography} from '@mui/material';
import {TabContext, TabList} from '@mui/lab';
import {COLORS} from 'shared/constants/AppEnums';
import AppsContainer from '@crema/core/AppsContainer';
import ListView from './ListView';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import clsx from 'clsx';
import DetailDokumen from './DetailDokumen';
import PropTypes from 'prop-types';
import {useDispatch} from 'react-redux';
import {
  onChangeFilter,
  onGetApprovalSK,
  onGetCompletedDigisign,
  onGetCompletedDigisignSk,
  onGetComposerDigisign,
  onGetDocumentCounter,
  onGetDraftDigisign,
  onGetInboxPK,
  onGetInprogressDigisign,
  onGetMonitoringListDigisign,
  onGetNeedSignSK,
  onGetRejectedDigisign,
  onGetRejectedDigisignPk,
  onGetRevisiDigisignSk,
  onGetSignedDigisign,
  onResetDigisign,
} from 'redux/actions/DigitalSign';
import {useSelector} from 'react-redux';
import TambahDokumen from './TambahDokumen';
import SignDokumenPk from './SignDokumenPk';
import {blue, green, grey, red, yellow} from '@mui/material/colors';
import { CardCounter } from 'shared/components/Cards'

const DokumenPk = () => {
  const {pathname} = useLocation();
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const {id} = useParams();
  const [refresh, setRefresh] = useState(false);
  const [monitoringRole, setMonitoringRole] = useState(false);
  const [monitoringStatus, setMonitoringStatus] = useState('');
  const {filter, dashboardSk} = useSelector((state) => state.digiSign);
  const {profileMe} = useSelector((state) => state.profile);
  const [tabValue, setTabValue] = useState('saya');
  const isMonitoringMode = monitoringRole && tabValue === 'monitoring';

  const isDetail =
    id !== undefined && pathname === `/apps/dokumen-pk/detail/${id}`;
  const isTambah =
    pathname === '/apps/dokumen-pk/tambah-dokumen' ||
    (id !== undefined && pathname === `/apps/dokumen-pk/tambah-dokumen/${id}`);
  // Pages that render in normal flow and use the page scrollbar instead of the list
  const isFullPage = isDetail || isTambah;

  const highlightSx = (status, color) => {
    const active = isMonitoringMode && monitoringStatus === status;
    return {
      borderRadius: '16px',
      width: {xs: '100%', md: 'auto'},
      flex: {md: 1},
      outline: `3px solid ${active ? color : 'transparent'}`,
      outlineOffset: '2px',
      transition: 'outline-color 0.2s ease',
    };
  };

  const handleCardClick = (state, status) => {
    if (isMonitoringMode) {
      setMonitoringStatus((prev) => (prev === status ? '' : status));
    } else {
      dispatch(onChangeFilter(state));
    }
  };

  const handleChangeTabValue = (event, newValue) => {
    setTabValue(newValue);
    setMonitoringStatus('');
  };

  useEffect(() => {
    dispatch(onResetDigisign());
  }, []);

  useEffect(() => {
    dispatch(onGetDocumentCounter('dokumen_pk', isMonitoringMode));
  }, [isMonitoringMode]);

  useEffect(() => {
    if (profileMe) {
      const monitoringRole =
        profileMe.roles_coofis.findIndex(
          (x) => x.state === 'MONITORING_PK',
        ) > -1
          ? true
          : false;

      setMonitoringRole(monitoringRole);
    }
  }, [profileMe]);

  useEffect(() => {
    if (pathname === '/apps/dokumen-pk') {
      if (!isMonitoringMode) {
        if (filter === 'composer')
          dispatch(onGetComposerDigisign('dokumen_pk'));
        else if (filter === 'pk-inbox') dispatch(onGetInboxPK('dokumen_pk'));
        else if (filter === 'draft') dispatch(onGetDraftDigisign('dokumen_pk'));
        else if (filter === 'rejected') dispatch(onGetRejectedDigisignPk());
        else if (filter === 'completed')
          dispatch(onGetSignedDigisign('dokumen_pk'));
        else if (filter === 'pk-need-sign')
          dispatch(onGetInprogressDigisign('dokumen_pk', '', 0, 10));
        else if (filter === 'pk-need-approval')
          dispatch(onGetApprovalSK('dokumen_pk', '', 0));
        else if (filter === 'pk-revisi')
          dispatch(onGetRevisiDigisignSk('dokumen_pk', '', 0));
      } else dispatch(onGetMonitoringListDigisign('dokumen_pk', '', 0, 10, monitoringStatus));
    }
  }, [dispatch, pathname, filter, refresh, tabValue, isMonitoringMode, monitoringStatus]);

  const renderBreadcrumb = () => {
    return (
      <Breadcrumbs aria-label='breadcrumb'>
        <Typography
          sx={{
            cursor: 'pointer',
            fontWeight: pathname === '/apps/dokumen-pk' ? 'bold' : '500',
          }}
          color={'primary.default'}
          variant='h3'
          onClick={() => {
            navigation(`/apps/dokumen-pk`);
          }}
        >
          Dokumen PK PPPK
        </Typography>
        {pathname === '/apps/dokumen-pk/tambah-dokumen' ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Tambah
          </Typography>
        ) : pathname === '/apps/dokumen-pk/tambah-dokumen/' + id &&
          id !== undefined ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Ubah Draft
          </Typography>
        ) : pathname === '/apps/dokumen-pk/tanda-tangan' ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Tanda Tangan
          </Typography>
        ) : id !== undefined && pathname === '/apps/dokumen-pk/detail/' + id ? (
          <Typography
            color={'primary.default'}
            sx={{cursor: 'pointer'}}
            variant='h3'
            fontWeight={'bold'}
          >
            Detail
          </Typography>
        ) : null}
      </Breadcrumbs>
    );
  };

  return (
    <AppsContainer
      fullView
      sxStyle={{
        '.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.css-1dmfeyv-MuiPaper-root-MuiCard-root':
          {
            height: '100% !important',
          },
        '.MuiBox-root.css-8jupnc': {
          height: 'fit-content',
          // width: '257px',
        },
        '.MuiBox-root.css-8jupnc, .MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded.MuiPaper-elevation1.MuiCard-root.css-1dmfeyv-MuiPaper-root-MuiCard-root':
          {
            transition: 'none !important',
            backgroundColor: 'transparent',
            boxShadow: 'none',
          },
        // On detail/tambah, let the container grow with its content so the page scrollbar is the only one
        ...(isFullPage && {
          overflow: 'visible',
          '& > .MuiBox-root:nth-of-type(2)': {
            height: 'auto !important',
          },
        }),
      }}
      // Clip only horizontally so the off-screen (translateX) overlays don't add a horizontal scrollbar
      cardStyle={isFullPage ? {overflowX: 'clip', overflowY: 'visible'} : undefined}
      title={renderBreadcrumb()}
    >
      {monitoringRole && !isFullPage && (
        <TabContext value={tabValue}>
          <TabList
            onChange={handleChangeTabValue}
            aria-label='dokumen pk tabs'
            TabIndicatorProps={{
              style: {backgroundColor: COLORS.primary, borderRadius: '16px'},
            }}
            sx={{
              backgroundColor: 'white',
              borderRadius: '16px',
              marginBottom: 2,
              '& .Mui-selected': {
                color: `${COLORS.primary} !important`,
                fontWeight: 'bold',
              },
              '& .MuiButtonBase-root.MuiTab-root': {
                borderRadius: '20px',
                fontSize: 16,
              },
              '& .MuiTabs-flexContainer': {gap: 2},
            }}
          >
            <Tab label='DOKUMEN SAYA' value='saya' />
            <Tab label='MONITORING' value='monitoring' />
          </TabList>
        </TabContext>
      )}
      {dashboardSk && (
        <Stack
          direction={{xs: 'column', md: 'row'}}
          spacing={2}
          className='my-2'
          alignItems={'center'}
          sx={{display: isFullPage ? 'none' : 'flex'}}
        >
          <Box sx={highlightSx('sk-need-approval', yellow[500])}>
            <CardCounter
              title='Need Approval'
              description=''
              value={dashboardSk?.need_approval}
              color={yellow[500]}
              onClick={() => handleCardClick('pk-need-approval', 'sk-need-approval')} 
              icon={'AssignmentLateOutlined'}
            />
          </Box>

          <Box sx={highlightSx('sk-need-sign', blue[500])}>
            <CardCounter
              title='Need Sign'
              description=''
              value={dashboardSk?.need_sign}
              onClick={() => handleCardClick('pk-need-sign', 'sk-need-sign')} 
              color={blue[500]}
              icon={'AssignmentLateOutlined'}
            />
          </Box>

          <Box sx={highlightSx('revisi', red[500])}>
            <CardCounter
              title='Revisi'
              description=''
              value={dashboardSk?.revisi}
              onClick={() => handleCardClick('pk-revisi', 'revisi')}    
              color={red[500]}
              icon={'AssignmentLateOutlined'}
            />
          </Box>  

          <Box sx={highlightSx('signed', green[500])}>
            <CardCounter
              title='Telah Selesai'
              value={dashboardSk?.done}
              onClick={() => handleCardClick('completed', 'signed')}
              description=''
              color={green[500]}
              icon={'AssignmentTurnedInOutlined'}
            />
          </Box>
        </Stack>
      )}
      {/* Keep the list mounted (to preserve its state) but out of the layout while detail/tambah is open */}
      <Box sx={{display: isFullPage ? 'none' : 'contents'}}>
        <ListView setRefresh={setRefresh} isMonitoring={isMonitoringMode} monitoringStatus={monitoringStatus} />
      </Box>

      <Box
        sx={{
          transition: 'all 0.5s ease',
          transform: 'translateX(100%)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100% !important',
          zIndex: 1,
          opacity: 0,
          visibility: 'hidden',
          backgroundColor: '#f4f7fe',
          '&.show': {
            // In normal flow so the page scrollbar is the only scrollbar
            position: 'relative',
            height: 'auto !important',
            width: '100%',
            transform: 'translateX(0)',
            opacity: 1,
            visibility: 'visible',
          },
        }}
        className={clsx({
          show: isDetail,
        })}
      >
        <DetailDokumen setRefresh={setRefresh} />
      </Box>

      <Box
        sx={{
          transition: 'all 0.5s ease',
          transform: 'translateX(100%)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100% !important',
          zIndex: 1,
          opacity: 0,
          visibility: 'hidden',
          backgroundColor: '#f4f7fe',
          '&.show': {
            // In normal flow so the page scrollbar is the only scrollbar
            position: 'relative',
            height: 'auto !important',
            width: '100%',
            transform: 'translateX(0)',
            opacity: 1,
            visibility: 'visible',
          },
        }}
        className={clsx({
          show: isTambah,
        })}
      >
        <TambahDokumen key={pathname} />
      </Box>

      <Box
        sx={{
          transition: 'all 0.5s ease',
          transform: 'translateX(100%)',
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100% !important',
          zIndex: 1,
          opacity: 0,
          visibility: 'hidden',
          backgroundColor: '#f4f7fe',
          '&.show': {
            width: '100%',
            transform: 'translateX(0)',
            opacity: 1,
            visibility: 'visible',
          },
        }}
        className={clsx({
          show: pathname === '/apps/dokumen-pk/tanda-tangan',
        })}
      >
        <SignDokumenPk />
      </Box>
    </AppsContainer>
  );
};

export default DokumenPk;